export default __webpack_public_path__ + "static/media/img_vision_02_m.4b54b122.png";